/* Chordly PDP interactions. Replaces the Replo runtime (replocdn.com) for the
   Chordly product page: hero image fade carousel + thumbnails, testimonial
   slider, and the CTA buttons that scroll to the buy box. The add-to-cart
   logic lives in the page markup (snippets/chordly-pdp-*.liquid) and is not
   touched here. No dependencies. */
(function () {
  'use strict';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- CTA buttons: scroll to the buy box ---------- */
  function wireScrollButtons() {
    var target = document.getElementById('buybox');
    if (!target) return;
    $$('.r-1pb224n, .r-hk52z7, .r-10ze594').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* ---------- Hero: fade carousel driven by thumbnails + swipe ---------- */
  function initHero() {
    var ROOT = 'replo-carousel:Rndoj2:';
    var track = $('[data-replo-root-id="' + ROOT + '"][data-replo-part="slide-track"]');
    if (!track) return;
    var slides = $$('[data-replo-root-id="' + ROOT + '"][data-replo-part="slide"]', track);
    var carousel = track.closest('[data-replo-carousel]');
    var thumbs = carousel ? $$('picture[role="button"]', carousel) : [];
    var live = carousel ? $('.replo-sr-only', carousel) : null;
    var n = slides.length;
    if (!n) return;
    var current = 0;

    slides.forEach(function (s, i) {
      s.style.left = 'calc(-' + i + ' * (100% + var(--replo-gap, 0px)))';
      s.style.transitionProperty = 'opacity, visibility';
      s.style.transitionDuration = '250ms';
      s.style.transitionTimingFunction = 'ease';
    });

    function show(i) {
      i = ((i % n) + n) % n;
      current = i;
      slides.forEach(function (s, j) {
        var on = j === i;
        s.style.opacity = on ? '1' : '0';
        s.style.pointerEvents = on ? '' : 'none';
        if (on) {
          s.setAttribute('data-is-active', 'true');
          s.setAttribute('data-is-target', 'true');
          s.removeAttribute('aria-hidden');
          s.removeAttribute('inert');
        } else {
          s.removeAttribute('data-is-active');
          s.removeAttribute('data-is-target');
          s.setAttribute('aria-hidden', 'true');
          s.setAttribute('inert', 'true');
        }
      });
      thumbs.forEach(function (t, j) {
        var on = j === i;
        t.setAttribute('aria-current', on ? 'true' : 'false');
        t.classList.toggle('r-8gd2ce', on);
        var img = t.querySelector('img');
        if (img) img.classList.toggle('r-1yistgr', on);
      });
      if (live) live.textContent = 'Slide ' + (i + 1) + ' of ' + n;
    }

    thumbs.forEach(function (t, j) {
      t.addEventListener('click', function () { show(j); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); show(j); }
      });
    });

    addSwipe(track.parentElement, function (dir) { show(current + dir); });
    show(0);

    // Hidden slides are lazy in the markup; fetch them once the page has loaded
    // so a thumbnail click switches instantly, like the Replo version did.
    function warm() {
      slides.forEach(function (s) {
        var img = s.querySelector('img');
        if (img && img.loading === 'lazy') img.loading = 'eager';
      });
    }
    if (document.readyState === 'complete') warm();
    else window.addEventListener('load', warm);
  }

  /* ---------- Testimonials: looping slider, 1 / 3 / 4 per page ---------- */
  function initTestimonials() {
    var ROOT = 'replo-carousel:Rbp32:';
    var track = $('[data-replo-root-id="' + ROOT + '"][data-replo-part="slide-track"]');
    if (!track) return;
    var carousel = track.closest('[data-replo-carousel]');
    var live = carousel ? $('.replo-sr-only', carousel) : null;

    // Keep only the original slides (the markup ships with pre-made clones).
    var originals = $$('[data-replo-root-id="' + ROOT + '"][data-replo-part="slide"]', track).filter(function (s) {
      return s.getAttribute('data-slide-index') === s.getAttribute('data-slide-source-index');
    });
    var n = originals.length;
    if (!n) return;
    var perPage = 1, index = 0, slideStep = 0, animating = false;

    function pageSize() {
      var w = window.innerWidth;
      return w <= 640 ? 1 : (w <= 1024 ? 3 : 4);
    }

    function clone(src, idx) {
      var c = src.cloneNode(true);
      c.setAttribute('data-is-cloned', 'true');
      c.setAttribute('aria-hidden', 'true');
      c.setAttribute('data-slide-index', String(idx));
      c.removeAttribute('data-is-active');
      c.removeAttribute('id');
      return c;
    }

    function build() {
      perPage = pageSize();
      track.innerHTML = '';
      var i;
      for (i = 0; i < perPage; i++) {
        track.appendChild(clone(originals[(n - perPage + i + n * perPage) % n], i - perPage));
      }
      originals.forEach(function (o, k) {
        o.removeAttribute('data-is-cloned');
        o.setAttribute('data-slide-index', String(k));
        track.appendChild(o);
      });
      for (i = 0; i < perPage; i++) {
        track.appendChild(clone(originals[i % n], n + i));
      }
      track.style.setProperty('--replo-carousel-slides-per-page', String(perPage));
      measure();
      jump(perPage);
    }

    function measure() {
      var first = track.children[0];
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      slideStep = first ? first.getBoundingClientRect().width + gap : 0;
    }

    function setTransform(i, animate) {
      track.style.transitionProperty = animate ? 'transform' : 'none';
      track.style.transitionDuration = animate ? '250ms' : '0ms';
      track.style.transitionTimingFunction = 'ease';
      track.style.transform = 'translate3d(' + (-i * slideStep) + 'px, 0px, 0px)';
    }

    function mark() {
      var logical = (((index - perPage) % n) + n) % n;
      originals.forEach(function (o, k) {
        if (k === logical) { o.setAttribute('data-is-active', 'true'); o.removeAttribute('aria-hidden'); }
        else { o.removeAttribute('data-is-active'); o.setAttribute('aria-hidden', 'true'); }
      });
      if (live) live.textContent = 'Slide ' + (logical + 1) + ' of ' + n;
    }

    function jump(i) { index = i; setTransform(i, false); mark(); }

    function go(dir) {
      if (animating) return;
      animating = true;
      index += dir;
      setTransform(index, true);
      mark();
      var finished = false;
      var done = function () {
        if (finished) return;
        finished = true;
        track.removeEventListener('transitionend', done);
        animating = false;
        if (index >= n + perPage) jump(index - n);
        else if (index < perPage) jump(index + n);
      };
      track.addEventListener('transitionend', done);
      setTimeout(done, 320);
    }

    if (carousel) {
      $$('[data-replo-part="nav-button"]', carousel).forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          go(b.getAttribute('data-direction') === 'previous' ? -1 : 1);
        });
      });
    }
    addSwipe(track.parentElement, function (dir) { go(dir); });

    var timer;
    window.addEventListener('resize', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (pageSize() !== perPage) { build(); }
        else { measure(); jump(index); }
      }, 120);
    });

    build();
  }

  /* ---------- Shared: horizontal swipe ---------- */
  function addSwipe(el, onSwipe) {
    if (!el) return;
    var x0 = null, y0 = null;
    // A native image drag would cancel the pointer stream; block it inside the slider.
    el.addEventListener('dragstart', function (e) { e.preventDefault(); });
    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      x0 = e.clientX; y0 = e.clientY;
      try { el.setPointerCapture(e.pointerId); } catch (err) {}
    });
    el.addEventListener('pointerup', function (e) {
      if (x0 === null) return;
      var dx = e.clientX - x0, dy = e.clientY - y0;
      x0 = y0 = null;
      try { el.releasePointerCapture(e.pointerId); } catch (err) {}
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) onSwipe(dx < 0 ? 1 : -1);
    });
    el.addEventListener('pointercancel', function () { x0 = y0 = null; });
  }

  function init() {
    wireScrollButtons();
    initHero();
    initTestimonials();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
